export const GOOGLE_MAPS_API_KEY = "AIzaSyCA1aGzWzbcYD-XEGmVf1fzOBbON8OKwH4";

export const MAP_DEFAULTS = {
  center: { lat: 34.05, lng: -118.35 },
  zoom: 11,
};
